import { render } from "./ResearchScaleFilter.vue?vue&type=template&id=33531d1c"
import script from "./ResearchScaleFilter.vue?vue&type=script&lang=js"
export * from "./ResearchScaleFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__